import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import column from './column'
import { toJS } from 'mobx'
import { observer } from 'mobx-react'
import { Table } from 'hljd'
import store from './store'
import styles from './style.module.less'

@observer
export default class extends Component {
  componenDidMount() {
    store.getList()
  }

  render() {
    const { list, pagination, this_month_count } = store
    let header = [
      <a href="#/localMerchant/home">我的店铺</a>,
      <a href="#/localMerchant/myShop">商家等级</a>,
      <a href="#/localMerchant/myShop/regular">等级规则</a>,
      '违规记录'
    ]

    return (
      <HeaderView title="违规记录" header={header}>
        <div className={styles.box}>
          <div className={styles.rule}>
            你本月已有违规记录：{this_month_count}
            <span>（违规行为会影响您的商家等级）</span>
          </div>

          <Table
            dataSource={toJS(list)}
            columns={column}
            pagination={pagination}
            onChange={store.setPage}
            rowKey={record => record.id}
          />
        </div>
      </HeaderView>
    )
  }
}
